export const Bio = {
    name: "Mohammad Zeeshan",
    roles: [
      "Software Engineer",
      "Tech Enthusiast",
      "Programmer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/ZestyZeeshan",
    resume:
      "https://drive.google.com/file/d/1SpDLwjwzwWu54gAK5f3hs9ALVtj_jjXo/view?usp=drive_link",
    linkedin: "https://www.linkedin.com/in/mohammadzeeshan19",
    twitter: "https://x.com/Zesty_Zeeshan19?t=72Jg6G0apB1bkv1gS1EeOw&s=09",
    insta: "https://www.linkedin.com/in/mohammadzeeshan19",
    
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "https://imgs.search.brave.com/ZWiVnNrgPmojOlU1ETwMAqt2-4m7KeDBwIHivAR7kMs/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly93d3cu/cG5naXRlbS5jb20v/cGltZ3MvbS82NjQt/NjY0NDUwOV9pY29u/LXJlYWN0LWpzLWxv/Z28taGQtcG5nLWRv/d25sb2FkLnBuZw",
        },
        // {
        //   name: "Redux",
        //   image:
        //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        // },
        // {
        //   name: "Next Js",
        //   image:
        //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        // },
        {
          name: "HTML5",
          image: "https://imgs.search.brave.com/mAHT62otwTCbRhY3h8lYvZHpaEAoB1qaV5tIVgEPsBw/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9hc3Nl/dHMuc3RpY2twbmcu/Y29tL2ltYWdlcy81/ODQ3ZjViZGNlZjEw/MTRjMGI1ZTQ4OWMu/cG5n",
        },
        {
          name: "CSS",
          image:
            "https://imgs.search.brave.com/aEGiTSo22dl3ju1IuSx7-Ex0GTyZ0ELtoLb2u8BWqBY/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YTIuZGV2LnRvL2R5/bmFtaWMvaW1hZ2Uv/d2lkdGg9ODAwLGhl/aWdodD0sZml0PXNj/YWxlLWRvd24sZ3Jh/dml0eT1hdXRvLGZv/cm1hdD1hdXRvL2h0/dHBzOi8vZGV2LXRv/LXVwbG9hZHMuczMu/YW1hem9uYXdzLmNv/bS91cGxvYWRzL2Fy/dGljbGVzLzdqMzUz/djh4ZTFoODYxdWM1/aTUzLnBuZw",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Tailwind Css",
          image:
            "https://imgs.search.brave.com/OuVzKQATBpkjUEzdkousMuLV1e3Pp3T4vN0XPU2n_ag/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9sb2dv/d2lrLmNvbS9jb250/ZW50L3VwbG9hZHMv/aW1hZ2VzL3RhaWx3/aW5kLWNzczMyMzIu/bG9nb3dpay5jb20u/d2VicA",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "PostgreSQL",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        
        // {
        //   name: "Flutter",
        //   image:
        //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
       // },
      ],
    },
    // {
    //   title: "Backend",
    //   skills: [
    //     {
    //       name: "Node Js",
    //       image: "https://nodejs.org/static/images/logo.svg",
    //     },
    //     {
    //       name: "Express Js",
    //       image:
    //         "https://imgs.search.brave.com/iINEWQ_-PYLlAzAFIr1qfyxVh_dTazx2_tok46gZdcU/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9raW5z/dGEuY29tL3dwLWNv/bnRlbnQvdXBsb2Fk/cy8yMDIyLzA0L2V4/cHJlc3MtMS5wbmc",
    //     },
    //     {
    //       name: "Graph Ql",
    //       image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
    //     },
    //     {
    //       name: "Python",
    //       image:
    //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    //     },
    //     {
    //       name: "MySQL",
    //       image:
    //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
    //     },
    
    //     {
    //       name: "MongoDB",
    //       image:
    //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
    //     },
    //     {
    //       name: "Firebase",
    //       image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
    //     },
    //   ],
    // },
    {
      title: "Data Science",
      skills: [
        // {
        //   name: "Java",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        // },
        {
          name: "Python",
          image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "Matplotlib",
          image:
            "https://imgs.search.brave.com/ZSbg82NL1CYOGu8HQNNwdYWXqiITq6vAhA7bP2IW4DA/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9weXRo/b24tZ3JhcGgtZ2Fs/bGVyeS5jb20vc3Rh/dGljLzRlYzUyN2E5/NTBiNzRmYmFiMzk1/NjdiZWQ1NTAwNDky/L2I1NjU4L21hdHBs/b3RsaWIucG5n",
        },
        {
          name: "Jupyter Notebook",
          image:
            "https://imgs.search.brave.com/G1vckuPLjJHFgWD9gYm98jExn9Srglk03OaOqYV7plA/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy90/aHVtYi8zLzM4L0p1/cHl0ZXJfbG9nby5z/dmcvMjIwcHgtSnVw/eXRlcl9sb2dvLnN2/Zy5wbmc",
        },
        {
          name: "NumPy",
          image:
            "https://imgs.search.brave.com/frgYZ0gL9Ffz7P6GMGOQqneFvePTQZdVvJpE5CieXZU/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9udW1w/eS5vcmcvaW1hZ2Vz/L2xvZ28uc3Zn",
        },
        {
          name: "Pandas",
          image:
            "https://imgs.search.brave.com/MinPg_S9zts-p6UP8AfPHbay9fmxN6zTcd3UWnYfDG0/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jYW1v/LmdpdGh1YnVzZXJj/b250ZW50LmNvbS8w/YTQyYWM4ZjkyMWUw/MWNhZTJhMGQ4MTdj/NjE1NDVlZWFiNjJl/NzljZmQ3NTcyMDg2/OGI0N2UxNTU5NTRh/YTgwLzY4NzQ3NDcw/NzMzYTJmMmY3MDYx/NmU2NDYxNzMyZTcw/Nzk2NDYxNzQ2MTJl/NmY3MjY3MmY3Mzc0/NjE3NDY5NjMyZjY5/NmQ2NzJmNzA2MTZl/NjQ2MTczMmU3Mzc2/Njc.jpeg",
        },
        
      ],
    },
    {
      title: "Others",
      skills: [
        
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
       
        // {
        //   name: "Docker",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        // },
        // {
        //   name: "Netlify",
        //   image:
        //     "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        // },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Java",
          image:
            "https://www.macworld.com/wp-content/uploads/2023/01/learn_java_on_mac.jpg?quality=50&strip=all",
        },
        {
          name: "Git",
          image:
            "https://imgs.search.brave.com/o7_nXYazTBWdBT2-IHPIwUuB6N71Tj_oz4zS2rIPA_I/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9sb2dv/cy1kb3dubG9hZC5j/b20vd3AtY29udGVu/dC91cGxvYWRzLzIw/MjEvMDEvR2l0X0xv/Z28tNzAweDcwMC5w/bmc",
        },
        // {
        //   name: "Postman",
        //   image:
        //     "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
        // },
        // {
        //   name: "Adobe XD",
        //   image:
        //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
        // },
        {
          name: "Jira",
          image:
            "https://imgs.search.brave.com/ddfvz1PNsKdpUB4l-_wA6kwvs5qDNU85ofcM4l_6dAY/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly93YWMt/Y2RuLmF0bGFzc2lh/bi5jb20vZGFtL2pj/cjpmYTAxNzU2ZC02/ZGNjLTQ1ZDEtODNh/Yi02OTZmYmZlYjA3/NGYvSmlyYS1pY29u/LWJsdWUuc3ZnP2Nk/blZlcnNpb249MjQ1/Nw",
        },
      ],
    },
  ];
  
  // export const experiences = [
  //   {
  //     id: 0,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //     role: "DevOps & Fullstack Engineering Intern",
  //     company: "Flipr Inovations Pvt. Ltd.",
  //     date: "Aug 2023 - July 2023",
  //     desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
  //     skills: [
  //       "Docker",
  //       "Terraform",
  //       "AWS",
  //       "EC2",
  //       "Portainer",
  //       "Nginx",
  //       "JavaScript",
  //       "TypeScript",
  //       "Node Js",
  //       " Next Js",
  //     ],
  //     doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  //   },
  //   {
  //     id: 0,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
  //     role: "Frontend Engineer Intern",
  //     company: "Neurobit",
  //     date: "June 2023 - Present",
  //     desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
  //     skills: [
  //       "ReactJS",
  //       "Redux",
  //       "NodeJs",
  //       "Material UI",
  //       "HTML",
  //       "CSS",
  //       "JavaScript",
  //     ],
  //     doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  //   },
  //   {
  //     id: 1,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //     role: "Fullstack Externship",
  //     company: "Flipr",
  //     date: "June 2023 - July 2023",
  //     desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
  //     skills: [
  //       "ReactJS",
  //       "Redux",
  //       "NodeJs",
  //       "Material UI",
  //       "HTML",
  //       "CSS",
  //       "JavaScript",
  //       "Docker",
  //       "AWS",
  //       "MongoDB",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
  //     role: "Open Source Contributor ",
  //     company: "GirlScript Summer of Code",
  //     date: "May 2023 - Present",
  //     desc: "Contributing to different open-source projects and learn from industry experts",
  //     doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  //   },
  //   {
  //     id: 3,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
  //     role: "Android Developer",
  //     company: "DSC KIIT",
  //     date: "Nov2021 - Present",
  //     desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
  //     skills: [
  //       "Leadership",
  //       "Mobile Application Development",
  //       "Kotlin",
  //       "XML",
  //       "Figma",
  //     ],
  //   },
  //   {
  //     id: 4,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
  //     role: "Android Developer Intern",
  //     company: "Rudraksha Welffare Foundation",
  //     date: "June 2021 - Oct 2021",
  //     desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
  //     skills: [
  //       "Android",
  //       "Java",
  //       "Kotlin",
  //       "XML",
  //       "Node Js",
  //       "Cloud Firestore",
  //       "Firebase",
  //       "Figma",
  //     ],
  //     doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  //   },
  // ];
  
  export const education = [
    {
      id: 0,
      img: "https://imgs.search.brave.com/wVDZiy3ArFmIu23L65K0i28wYcEH2tso79rIMUf6laA/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/Y29sbGVnZXByYXZl/c2guY29tLzIwMTYv/MDUvQmhhcmF0aS1W/aWR5YXBlZXRoLUxv/Z28uanBn",
      school: " Bharati Vidyapeeth's College of Engineering, Delhi",
      date: "Oct 2021 - July 2025",
      grade: "8.4 CGPA",
      desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering with minor in Data Science at  Bharati Vidyapeeth's College of Engineering, Delhi. I have completed 7 semesters and have a CGPA of 8.5. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the IEEE at BVCOE, where I am learning and working on exciting projects with a team of talented developers.",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyi0tL8RjgTVdLrHSqXygCJpUYqbr7K6DXIg&s",
      school: "GB Pant Institute of Technology, New Delhi",
      date: "Aug 2018 - May 2021",
      grade: "83.2%",
      desc: "I completed my diploma in Mechanical Engineering from GB Pant Institute of Technology.",
      degree: "BTE(Delhi), Mechanical Engineering",
    },
    {
      id: 2,
      img: "https://imgs.search.brave.com/kHNUCGFoE3Wm5JhZtiycCrn0YlQ4KkQgT3sFYnkqYhg/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9zZWVr/bG9nby5jb20vaW1h/Z2VzL0ovamFtaWEt/bWlsbGlhLWlzbGFt/aWEtbG9nby1BMkVC/Q0YwMjBBLXNlZWts/b2dvLmNvbS5wbmc",
      school: "Jamia Senior Secondary School,New Delhi",
      date: "Apr 2017 - Apr 2018",
      grade: "85.3%",
      desc: "I completed my class 10 at Jamia Millia Islamia, New Delhi.",
      degree: "Jamia Board(X), Secondary School Certificate",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "ZestyFood",
      date: "Dec 2023 - Feb 2024",
      description:
        "ZestyFood is a food ordering app that utilizes the live Swiggy API for real-time data updates on breakfast, lunch, and dinner menus. Users can add or delete items from their cart and enjoy various features like an optimized search option to enhance their experience. The app is designed to provide a seamless and efficient food ordering process with many additional functionalities. (PLEASE ENABLE CORS EXTENTION FOR LIVE LINK)",
      image:
        "https://github.com/user-attachments/assets/61491679-f1aa-4e3e-9d1f-5026cb54382c",
      tags: ["React Js", "Tailwind CSS", "Swiggy API", "Redux","Redux Toolkit" ],
      category: "web app",
      github: "https://github.com/ZestyZeeshan/ZestyFoodApp/tree/main",
      webapp: "https://zesty-hunger-junction.netlify.app/",
      
    },
    {
      id: 9,
      title: "TherapEase",
      date: "Mar 2024 - May 2024",
      description:
        "TherapEase is a comprehensive web application for mental health, providing information on issues like depression and anxiety that are often not openly discussed in society. It features a 24/7 free mental health chatbot for interactive support and offers a classification system for initial alerts about mental health conditions. Additionally, TherapEase includes resources and tools to help users understand and manage their mental health better.",
      image:
        "https://github.com/user-attachments/assets/3f9eb8c8-be5b-4efe-9db9-590b9ab7ee52",
      tags: [
        
        "React Js",
        "Tailwind CSS",
        "ChatBot",
        "Machine Learning",
        "Google Gemini",
      ],
      category: "web app",
      github: "https://github.com/ZestyZeeshan/TherapEase",
      webapp: "https://therap-ease-six.vercel.app/",
      member: [
        {
          name: "Mohammad Zeeshan",
          img: "https://avatars.githubusercontent.com/u/141507225?v=4",
          linkedin: "https://www.linkedin.com/in/mohammadzeeshan19",
          github: "https://github.com/ZestyZeeshan",
        },
        // {
        //   name: "Upasana Chaudhuri",
        //   img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        //   linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        //   github: "https://github.com/upasana0710",
        // },
      ],
    },
    
    {
      id: 1,
      title: "Zest-Fashion",
      date: "Aug 2023 - Oct-2023",
      description:
        "Zest-Fashion is a responsive e-commerce web app designed for shopping. It retrieves data from a backend and includes essential functionalities such as adding items to the cart and various other features that enhance the user experience.",
      image:
        "https://github.com/ZestyZeeshan/Zest-Fashion/assets/141507225/7c3476e1-4656-442b-b65b-18df3388a486",
      tags: [
        "React Js",
        "Redux Toolkit",
        "Vite",
        "Bootstrap",
        "CSS"
      ],
      category: "web app",
      github: "https://github.com/ZestyZeeshan/Zest-Fashion/tree/main",
      webapp: "https://drive.google.com/file/d/152bPLa5Y3QQLLszohQ0AmTcen46yJLVV/view?usp=sharing",
    },
    {
      id: 2,
      title: "Portfolio",
      date: "jun 2024 - Jul 2024",
      description:
        "A responsive portfolio to showcase myself, including all my projects, education details, and resume. It's a one-stop platform for an initial representation of my skills and accomplishments.",
      image:
        "https://github.com/user-attachments/assets/99744681-9fdb-450a-a2b7-c16e3bdb470d",
      tags: ["React Js", "Redux", "Dynamic Data", "MATERIAL UI", ],
      category: "web app",
      //"machine learning",
      github: "https://github.com/ZestyZeeshan/Portfolio/tree/main",
      webapp: "https://portfolio-ruby-alpha-86.vercel.app/",
      // member: [
      //   {
      //     name: "Rishav Chanda",
      //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
      //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
      //     github: "https://github.com/rishavchanda/",
      //   },
      //   {
      //     name: "Upasana Chaudhuri",
      //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
      //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
      //     github: "https://github.com/upasana0710",
      //   },
      // ],
    },
    {
      id: 3,
      title: "Mental Health ChatBot",
      date: "Jul 2023 - Nov 2023",
      description:
        "A mental health chatbot that utilizes a dataset of conversations between users and mental health consultants. The chatbot encodes and decodes these conversations for storage in a database. Using a similarity index, it retrieves answers from this dataset. If a question is not found in the database, it retrieves the response from the Gemini API.",
      image:
        "https://github.com/user-attachments/assets/66482da4-aeba-48ce-88c4-e058f9a3f7a0",
      tags: ["Streamlit", "Gemini API","Encoding-Decoding", "Generative Ai", "CSV Dataset","Kaggle"],
      category: "machine learning",
      github: "https://github.com/ZestyZeeshan/Chatbot_TherapEase",
      webapp: "https://chatbot-therapease.streamlit.app/",
    },
    {
      id: 10,
      title: "Book Recommender",
      date: "May 2023 - Jul 2023",
      description:
        "A book recommender system that suggests books based on user feedback through ratings and the number of users who have read each book. These personalized recommendations enhance the user experience by offering tailored book suggestions.",
      image:
        "https://github.com/ZestyZeeshan/Book-Recommend/assets/141507225/5d3d4dfb-b6b9-4f62-9565-70c36f3c03f6",
      tags: ["Machine Learning", "Supervised Learning", "Flask","Python"],
      category: "machine learning",
      github: "https://github.com/ZestyZeeshan/Book-Recommend/tree/main",
      webapp: "https://drive.google.com/file/d/1fAVW66MZPdxIaOcdk4IJR1g86ujh8Yj9/view?usp=sharing",
    },
    // {
    //   id: 4,
    //   title: "Whatsapp Clone",
    //   date: "Jul 2021",
    //   description:
    //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    //   image:
    //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    //   webapp: "https://whatsapp-clone-rishav.web.app",
    // },
    // {
    //   id: 5,
    //   title: "Todo Web App",
    //   date: "Jun 2021",
    //   description:
    //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    //   image:
    //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Todo-Web-App",
    //   webapp: "https://rishav-react-todo.netlify.app/",
    // },
    // {
    //   id: 6,
    //   title: "Breaking Bad",
    //   date: "Jun 2021",
    //   description:
    //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
    //   image:
    //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
    //   tags: ["React Js", "API", "Axios", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Breaking-Bad",
    //   webapp: "https://breaking-bad-webapp.netlify.app",
    // },
    // {
    //   id: 7,
    //   title: "Quiz App",
    //   date: "Dec 2020 - Jan 2021",
    //   description:
    //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    //   image:
    //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Quiz-Earn",
    //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
    // },
    // {
    //   id: 8,
    //   title: "Face Recognition",
    //   date: "Jan 2021",
    //   description:
    //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    //   image:
    //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
    //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    //   category: "machine learning",
    //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    // },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];